<template>
    <div>
        <button class="btn btn-dark btn-lg btn-block" v-on:click="registerForm()"> 註冊管理員帳號 </button>

        <div class="modal fade" ref="exampleModalCenter">
            <div class="modal-dialog modal-dialog-centered">
                <form style="width: 500px; padding: 20px; background-color:#fff;border: 1px solid rgba(0, 0, 0, 0.125);"
                    v-on:submit.prevent="adminRegister" class="modal-content">
                    <div class="form-group">
                        <label for="exampleInputtext">帳號</label>
                        <input type="text1" class="form-control" id="exampleInputemail" aria-describedby="emailHelp"
                            placeholder="請輸入帳號" required="required" v-model="username">
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">密碼</label>
                        <input type="password" class="form-control" id="exampleInputPassword" placeholder="請輸入密碼"
                            required="required" v-model="password">
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">密碼確認</label>
                        <input type="password" class="form-control" id="exampleInputPassword1" placeholder="再輸入一次密碼"
                            required="required" v-model="password_confirmation">
                        <div class="text-danger" v-if="this.password_equal">密碼錯誤</div>
                    </div>

                    <button type="submit" class="btn btn-primary"
                        style="margin: 0 auto; display: flex; padding: 10px 60px;">註冊</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            username: '',
            password: '',
            password_confirmation: '',
            base_url
        }
    },
    computed: {
        password_equal() {
            return this.password !== this.password_confirmation;
        }
    },
    methods: {
        adminRegister: function () {
            axios
                .post(base_url + '/admin/api/register', {
                    username: this.username,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                })
                .then((response) => {
                    if (response.data.message == "register succeed.") {
                        alert('註冊成功');
                        Turbolinks.visit(this.base_url + '/admin/index');
                    }
                    console.log(response);
                })
                .catch(function (error) {
                    if (error.response.data.errors.username == "The username has already been taken.") {
                        alert('帳號已註冊');
                    } else if (error.response.data.errors.password == "The password must be at least 8 characters.") {
                        alert('密碼需8位數')
                    }
                });
        },
        registerForm: function () {
            $(this.$refs.exampleModalCenter).modal('show');
        }
    }
}
</script>
